import React from "react";
import { Container } from "react-bootstrap";
import "./Footer.css";

const Footer = () => {
  return (
    <Container className="font text-center mb-2 mt-4">
      <p>Copyright © 2021 | moshiur rahman</p>
      Address: Kolabagan, Dhanmondi, Bangladesh.
      <br />
      <a
        className="footer-link"
        href="https://github.com/moshiur01"
        target="_blank"
        rel="noreferrer"
      >
        <i className="fab fa-github-square footer-link"></i>
      </a>
      <a
        className="footer-link"
        href="https://github.com/moshiur01"
        target="_blank"
        rel="noreferrer"
      >
        <i class="fab fa-linkedin footer-link mx-2"></i>
      </a>
    </Container>
  );
};

export default Footer;
